<template>
  <div class='dialog_menu search_menu' :class='{slide_in_right: show}'>
    <div class='top'>
      <div class='fz_0 text_center'>
        <div class='icon icon_goods_search'></div>
        <input v-model='inputValue' type='text' :placeholder='$t("goods.search.placeholder")' class='dis_ib'>
        <div class='more' @click='searchGood'>{{ inputValue.length ? $t('goods.search.button') : $t('goods.search.cancel') }}</div>
      </div>
    </div>
    <div class='line'></div>
    <div class='menu_list'>
      <div class='dis_ib ver_m'>{{ $t('goods.category.hot') }}</div>
      <ul v-if='data'>
        <li v-for='(item, hindex) in data' :key='hindex.id' class='item' :class='{active: currentTagId === item.id}' @click='clickHotSearch(item.id)'>
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GoodsSearchMenu',
  props: ['data', 'show', 'currentTagId'],
  data () {
    return {
      inputValue: '',
    }
  },
  methods: {
    goPage (url) {
      this.$emit('close')
      this.$router.push(url)
    },
    searchGood () {
      this.$emit('close')
      if (!this.inputValue.length) return
      this.$emit('searchGood', this.inputValue)
    },
    clickHotSearch (id) {
      this.inputValue = ''
      this.$emit('close')
      this.$emit('clickHotSearch', id)
    },
  },
}
</script>
